import assignToThis from '../../helper/assignToThis';
import { EcoBreakdown } from './EcoBreakdown';
import { EcoFuture } from './EcoFuture';
import { EcoOM } from './EcoOM';
import {
  DepreciationTypeRef,
  FeedInPricingTypeRef,
  GridPricingTypeRef,
  ProjectFinancingStructureTypeRef,
  RevenuesTypeRef
} from './EcoReference';
import { GridComplexPricing } from './GridComplexPricing';
import { GridPricingFile } from './GridPricingFile';
import { ObjectOnly } from '@/classes/ObjectOnly';

export class ScenarioEco {
  // CAPEX

  public hasBreakdownCapex: boolean | null = null;

  public epcProposalFixed: number | null = null;

  public epcProposalVariable: number | null = null;

  public breakdown: EcoBreakdown | null = null;

  // CHECKED ==========================================

  public future: EcoFuture | null = null;

  // O&M

  public om: EcoOM | null = null;

  // Grid

  public gridPricingTypeRef: GridPricingTypeRef | null = null;

  public gridFixFee: number | null = null;

  public gridPrice: number | null = null;

  public gridMyFilePricing: GridPricingFile | null = null;

  public gridFixFeeEscalationRate: number | null = null;

  public gridPriceEscalationRate: number | null = null;

  public gridComplexPricing: GridComplexPricing | null = null;

  public gridFixFeeTax: number | null = 0;

  public gridPriceTax: number | null = 0;

  // Generator

  public fuelPrice: number | null = null;

  public fuelEscalationRate: number | null = null;

  public fuelPriceType1: number | null = null;

  public fuelEscalationRateType1: number | null = null;

  public fuelPriceType2: number | null = null;

  public fuelEscalationRateType2: number | null = null;

  // Feed In
  public feedInPricingTypeRef: FeedInPricingTypeRef | null = null;

  public feedInDuration: number | null = null;

  public feedInTariff: number | null = null;

  public feedInTariffEscalationRate: number | null = null;

  public feedInTariff2: number | null = null;

  public feedInTariffEscalationRate2: number | null = null;

  public hasPaymentForExcessAnnualGeneration: boolean | null = null;

  public feedInFlexibleTariff: GridPricingFile = new GridPricingFile();

  public feedInPPAvsMerchant: number | null = 1;

  public routeToMarket: number | null = null;

  // Affiliate Debt

  public useAffiliateDebt: boolean | null = null;

  public useFarmdown: boolean | null = null;

  public affiliateGearing: number | null = null;

  public minimumDscr: number | null = null;

  public tenor: number | null = null;

  public shortTermInterestRate: number | null = null;

  // Taxes

  public gensetTaxes: number | null = null;

  public shelterTaxes: number | null = null;

  public pvModuleTaxes: number | null = null;

  public pvRackingTaxes: number | null = null;

  public pvInverterTaxes: number | null = null;

  public batteryTaxes: number | null = null;

  public installationTaxes: number | null = null;

  // Fixed Yearly Cash Flow
  public additionalCashFlow: boolean | null = null;
  
  public fixedYearlyCashFlowOtherCost: number | null = null;

  public fixedYearlyCashFlowOtherCostYearsAffected: number | null = null;

  public totalAmountOverConstruction: number | null = null;

  // Revenues

  public revenuesTypeRef: RevenuesTypeRef | null = null;

  public ppaTakeOrPay: boolean | null = null;

  public minimumTakeOff: number | null = null;

  public contractDuration: number | null = null;

  public solarMonthlyFeePercentage: number | null = null;

  public solarMonthlyFeeYearlyInflation: number | null = null;

  public solarMonthlyFeeValue: number | null = null;

  public proportionOfSavings: number | null = null;

  public ppaPrice: number | null = null;

  public ppaYearlyInflation: number | null = null;

  // Others

  public corporateTaxRate: number | null = null;

  public discountRate: number | null = null;

  public currency: string | null = null;

  public exchangeRate: number | null = null;

  public inflationRateLocalCurrency: number | null = null;

  public inflationRateUSD: number | null = null;

  // Project Financing Structure

  public projectFinancingStructureTypeRef: ProjectFinancingStructureTypeRef | null = null;

  public lossCarryForwardLimit: number | null = null;
  public withholdingTaxOnDividends: number | null = null;
  public taxHoliday: number | null = null;

  // Depreciation

  public depreciationTypeRef: DepreciationTypeRef | null = null;

  public depreciationTime: number | null = null;
  public depreciationPercentage: number | null = null;

  // Tax Credit

  public hasTaxCredit: boolean | null = null;

  public taxCreditRate: number | null = null;

  public taxCreditYear: number | null = null;

  public constructor(obj: ObjectOnly = {}) {
    assignToThis(this, obj);

    this.breakdown = this.breakdown ? new EcoBreakdown(this.breakdown) : null;

    this.future = this.future ? new EcoFuture(this.future) : null;

    this.om = this.om ? new EcoOM(this.om) : null;

    this.gridComplexPricing = this.gridComplexPricing ? new GridComplexPricing(this.gridComplexPricing) : null;

    this.revenuesTypeRef = this.revenuesTypeRef
      ? (RevenuesTypeRef as any)[this.revenuesTypeRef]
      : null;

    this.projectFinancingStructureTypeRef = this.projectFinancingStructureTypeRef
      ? (ProjectFinancingStructureTypeRef as any)[this.projectFinancingStructureTypeRef] : null;

    this.depreciationTypeRef = this.depreciationTypeRef
      ? (DepreciationTypeRef as any)[this.depreciationTypeRef]
      : null;
  }
}
